'use strict'

module.exports = {
  getQueryParams(search = window.location.search) {
    const hashes = search.slice(search.indexOf('?') + 1).split('&')
    const params = {}
    hashes.forEach(hash => {
      const [key, val] = hash.split('=')
      params[key] = decodeURIComponent(val)
    })

    return params
  }
}